import '@fortawesome/fontawesome-svg-core/styles.css';
import '@monorepo/ui/styles/DOC/prism.css';

export * as global from '@monorepo/ui/styles/global.scss';

const config = require('@fortawesome/fontawesome-svg-core');

config.autoAddCss = false;

export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  const currentPosition = getSavedScrollPosition(location);
  window.scrollTo(...(currentPosition || [0, 0]));
  return false;
};
